import Button from "../../ui/Button";
import Modal from "../../ui/Modal";

interface GtfsFollowConfirmProps {
  show: boolean;
  nameChanged: boolean;
  locationChanged: boolean;
  canFollow: boolean;
  busy: boolean;
  onSaveAndFollow: () => void;
  onSaveOnly: () => void;
  onCancel: () => void;
}

// Asked before saving a station whose name or location is being changed while the GTFS feed
// still uses its own value for that field: save and make GTFS follow, save only, or cancel.
const GtfsFollowConfirm: React.FC<GtfsFollowConfirmProps> = ({
  show,
  nameChanged,
  locationChanged,
  canFollow,
  busy,
  onSaveAndFollow,
  onSaveOnly,
  onCancel
}) => {
  const fields = [nameChanged && "emrin", locationChanged && "vendndodhjen"].filter(Boolean).join(" dhe ");

  return (
    <Modal
      position="center"
      modalWidth="480px"
      title="GTFS përdor vlerat e veta"
      show={show}
      onClose={onCancel}
      fitContent
    >
      <div className="p-5 flex flex-col gap-4 text-sm">
        <p>
          Po ndryshoni {fields}, por feed-i GTFS për Google përdor vlerat e veta për këtë stacion.
          Google nuk do ta shohë këtë ndryshim derisa GTFS ta ndjekë përsëri stacionin.
        </p>
        <div className="flex flex-wrap justify-end gap-3">
          <Button
            type="button"
            btnType="custom"
            className="border border-gray-300"
            disabled={busy}
            onClick={onCancel}
          >
            Anulo
          </Button>
          <Button
            type="button"
            btnType="custom"
            className="border border-primary text-primary"
            disabled={busy}
            onClick={onSaveOnly}
          >
            Ruaj vetëm
          </Button>
          {canFollow && (
            <Button type="button" disabled={busy} onClick={onSaveAndFollow}>
              Ruaj dhe bëje GTFS të ndjekë
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default GtfsFollowConfirm;
